export enum Path {
    HOME = "/home",
    ABOUT = "/about-me",
    PROJECTS = "/resume",
    PROJECTS_PROGRAMS = "/resume/programs",
    ART = "/art",
    ART_FULL_SIZE = "/art/:index",
    XGEO = "/xgeo",
    XGEO_SOON = "/xgeo/coming-soon",
    XGEO_US = "/xgeo/na/license-plates",
    XGEO_US_ADOPT_A_HIGHWAY = "/xgeo/na/adopt-a-highway",
    XGEO_US_STATE_HIGHWAY = "/xgeo/na/state-highway",
    XGEO_US_COUNTY_SECONDARY_HIGHWAY = "/xgeo/na/county-secondary-highway",
    XGEO_US_STATE_FLAGS = "/xgeo/na/state-flags",
    XGEO_US_WINDSHIELD_STICKERS = "/xgeo/na/windshield-stickers",
    XGEO_NA_ABBREVIATIONS = "/xgeo/na/abbreviations",
    XGEO_NA_AREA_CODES = "/xgeo/na/area-codes",
    XGEO_NA_TREE_SPECIES = "/xgeo/na/tree-species",
    XGEO_BR = "/xgeo/br/phone-codes",
    XGEO_BR_ABBREVIATIONS = "/xgeo/br/abbreviations",
    XGEO_BR_POSTCODES = "/xgeo/br/postcodes",
    XGEO_EU = "/xgeo/eu",
    XGEO_EU_BOLLARDS = "/xgeo/eu/bollards",
    XGEO_EU_CHEVRONS = "/xgeo/eu/chevrons",
    XGEO_EU_DOMAINS = "/xgeo/eu/domains",
    XGEO_EU_GUARDRAILS = "/xgeo/eu/guardrails",
    XGEO_EU_FLAGS = "/xgeo/eu/flags",
    XGEO_EU_PEDESTRIAN_CROSSINGS = "/xgeo/eu/pedestrian-crossings",
    XGEO_MONG = "/xgeo/mongolia/driving-direction",
    XGEO_MONG_CAR_META = "/xgeo/mongolia/car-meta",
    XGEO_INDONESIA_KABUPATEN = "/xgeo/indonesia/kabupaten",
    XGEO_PHILLIPINES_PROVINCES = "/xgeo/philippines/provinces",
    XGEO_PHILLIPINES_REGIONS = "/xgeo/philippines/regions",
    XGEO_PHILLIPINES_PLATES = "/xgeo/philippines/plates",
    XGEO_VIETNAM_PROVINCES = "/xgeo/vietnam/provinces",
    XGEO_VIETNAM_AREA_CODES = "/xgeo/vietnam/area-codes",
    XGEO_VIETNAM_LICENSE_PLATE_CODES = "/xgeo/vietnam/license-plate-codes",
    XGEO_VIETNAM_REGIONAL_PLACE_NAMES = "/xgeo/vietnam/regional-place-names",
    XGEO_VIETNAM_POLES = "/xgeo/vietnam/poles",
    XGEO_NIGERIA_STATES = "/xgeo/nigeria/states",
    XGEO_KENYA_COUNTIES = "/xgeo/kenya/counties",
    XGEO_AUSTRALIA_PLATES = "/xgeo/australia/plates",
    XGEO_ZA_PLATES = "/xgeo/south-africa/plates",
    XGEO_ZA_PROVINCES = "/xgeo/south-africa/provinces",
    XGEO_JP_AREACODES = "/xgeo/japan/area-codes",
    XGEO_JP_PREFECTURES = "/xgeo/japan/prefectures",
    XGEO_JP_POLE_PLATES = "/xgeo/japan/pole-plates",
    XGEO_JP_POLE_REFLECTORS = "/xgeo/japan/pole-reflectors",
    XGEO_JP_POLE_ATTACHMENTS = "/xgeo/japan/pole-attachments",
    XGEO_JP_KANJI = "/xgeo/japan/kanji",
    XGEO_JP_REGIONS = "/xgeo/japan/regions",
    SOON = "/coming-soon",
    CREDITS = "/credits",
    EIGHTYEIGHT = "/88x31",
    DIGICAM = "/digicam",
    VISITORS = "/visitors",
    SUPPORT = "/support",
    ANNOUNCEMENTS = "/patch-notes",
    TRAVEL_LOG = "/travel-log",
    IN_THE_SKY = "/InTheSky", 
    GET_IN_THE_SKY = "/get-in-the-sky",
    STARS = "/stars",
    ANIGUESSR = "/ayaya",
    SITEMAP = "/sitemap",
}
